import {
  SEARCH_COMMANDS,
  SEARCH_COMMANDS_SUCCESS,
  SEARCH_COMMANDS_FAILURE,
  GET_COMMAND,
  GET_COMMAND_SUCCESS,
  GET_COMMAND_FAILURE,
  GET_RETURN_LABEL_SUCCESS,
  CLOSE_DRAWER,
  UPDATE_COMMAND_SUCCESS,
  UPDATE_ITEMS_SUCCESS,
  ADD_CHECKED_COMMAND_ID,
  REMOVE_CHECKED_COMMAND_ID,
  REMOVE_ALL_COMMANDS_IDS,
  CANCEL_COMMAND_SUCCESS,
  ADD_CHECKED_COMMANDS_IDS,
  DUPLICATE_COMMAND,
  DUPLICATE_COMMAND_SUCCESS,
  DUPLICATE_COMMAND_FAILURE
} from './commandsActions';

import { MERGE_COMMANDS_SUCCESS } from '../mergeCommands/mergeCommandsActions';

const initialState = {
  searchCommands: [],
  notSent: {
    commands: []
  },
  sentByMe: {
    commands: []
  },
  sentToMe: {
    commands: []
  },
  notSentCommandsIds: [],
  loading: true,
  loadingCurrentCommand: false,
  currentCommand: {},
  openDrawer: false,
  updateCommandWatch: false,
  checkedCommandsIds: []
};

/**
 * Réducer de la partie des commandes
 */
const commandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_DRAWER:
      return {
        ...state,
        openDrawer: false
      };
    case DUPLICATE_COMMAND:
      return {
        ...state,
        loading: true
      };
    case DUPLICATE_COMMAND_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case DUPLICATE_COMMAND_FAILURE:
      return {
        ...state,
        loading: false
      };
    case SEARCH_COMMANDS:
      return {
        ...state,
        loading: true
      };
    case SEARCH_COMMANDS_SUCCESS:
      return {
        ...state,
        searchCommands: action.payload.commands,
        numberOfCommands: action.payload.totalResults,
        loading: false
      };
    case SEARCH_COMMANDS_FAILURE:
      return {
        ...state,
        loading: false
      };
    case GET_COMMAND:
      return {
        ...state,
        loadingCurrentCommand: true,
        openDrawer: true
      };
    case GET_COMMAND_SUCCESS:
      return {
        ...state,
        currentCommand: action.payload.command,
        loadingCurrentCommand: false
      };
    case GET_COMMAND_FAILURE:
      return {
        ...state,
        loadingCurrentCommand: false,
        openDrawer: false
      };
    case UPDATE_ITEMS_SUCCESS:
    case UPDATE_COMMAND_SUCCESS:
      return {
        ...state,
        currentCommand: action.payload.command,
        updateCommandWatch: !state.updateCommandWatch
      };
    case CANCEL_COMMAND_SUCCESS:
      return {
        ...state,
        updateCommandWatch: !state.updateCommandWatch,
        openDrawer: false
      };
    case ADD_CHECKED_COMMAND_ID:
      return {
        ...state,
        checkedCommandsIds: [...state.checkedCommandsIds, action.payload]
      };
    case REMOVE_CHECKED_COMMAND_ID:
      return {
        ...state,
        checkedCommandsIds: state.checkedCommandsIds.filter(
          commandId => commandId !== action.payload
        )
      };
    case MERGE_COMMANDS_SUCCESS:
    case REMOVE_ALL_COMMANDS_IDS:
      return {
        ...state,
        checkedCommandsIds: []
      };
    case ADD_CHECKED_COMMANDS_IDS:
      return {
        ...state,
        checkedCommandsIds: action.data.commandsIds
      };
    case GET_RETURN_LABEL_SUCCESS:
      return {
        ...state,
        currentCommand: {
          ...state.currentCommand,
          returnLabelUrl: action.payload.labelUrl
        }
      };
    default:
      return state;
  }
};

export default commandsReducer;
